import styled from 'styled-components';
import { IconButton } from '@perch-labs/shrike';

export const Button = styled(IconButton)`
  border: 2px solid ${props => props.theme.colors.background.secondary};
  margin: 0 8px;

  &:focus {
    border: 2px solid ${props => props.theme.colors.content.primary};
    box-shadow: none;
  }
`;
